"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextFieldByConfig = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _reactHookForm = require("react-hook-form");
var _Localization = require("../../../Localization");
var _utils = require("../../../utils");
var _jsxRuntime = require("react/jsx-runtime");
const TextFieldStyled = (0, _mui.styled)(_mui.TextField)(({
  theme
}) => ({
  '& .MuiInputLabel-root': {
    paddingRight: theme.spacing(6)
  },
  '& .MuiFormLabel-root.MuiInputLabel-shrink': {
    paddingRight: theme.spacing(0)
  }
}));
const readOnlyStyleBox = {
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'start'
};
const TextFieldByConfig = props => {
  const {
    name,
    label,
    isEditable,
    isAvailable,
    displayOrder,
    validation,
    initialValue,
    isDisabled,
    placeholder,
    isMultiline = false
  } = props;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  let readOnly = false;
  const deliveryField = name.includes('delivery');
  if (!isAvailable) {
    return null;
  }
  if (validation && 'isAddressMatchRequired' in validation) {
    readOnly = validation.isAddressMatchRequired;
  }
  const regexPattern = validation?.regularExpression ? new RegExp(validation.regularExpression) : undefined;
  const dataTestId = getTestId((0, _utils.camelCaseToKebabCase)(name));
  const inputProps = {
    autoCorrect: 'off',
    autoComplete: 'off',
    role: 'presentation',
    maxLength: validation?.maxLength,
    minLength: validation?.minLength ?? undefined,
    placeholder,
    'data-testid': dataTestId
  };
  const title = _Localization.AddressHintMapper.getLocalizationKey(name);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
    size: {
      xs: 12
    },
    style: {
      order: displayOrder
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
      margin: readOnly ? '0' : '0 auto 15px',
      style: readOnly ? readOnlyStyleBox : undefined,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.Controller, {
        name: name,
        rules: {
          required: validation?.isMandatory,
          maxLength: validation?.maxLength,
          minLength: validation?.minLength,
          pattern: regexPattern
        },
        defaultValue: initialValue,
        render: ({
          field,
          fieldState
        }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.FormControl, {
          fullWidth: true,
          sx: {
            marginBottom: 0
          },
          children: readOnly ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(TextFieldStyled, {
            ...field,
            fullWidth: true,
            name: name,
            id: name,
            label: label,
            error: !!fieldState.error,
            helperText: fieldState.error ? (0, _utils.renderValidationMessage)(fieldState.error, validation) : title,
            multiline: isMultiline,
            disabled: isDisabled || !isEditable,
            required: validation?.isMandatory,
            variant: "outlined",
            InputProps: {
              ...inputProps,
              rows: deliveryField ? 3 : undefined,
              endAdornment: fieldState.error ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ErrorCircle, {
                color: "error"
              }) : null
            },
            sx: {
              mb: 0
            }
          })
        })
      })
    })
  });
};
exports.TextFieldByConfig = TextFieldByConfig;
//# sourceMappingURL=TextFieldByConfig.js.map